(function () {
  'use strict';

  function initCountdown(root) {
    var targetIso = root.getAttribute('data-target');
    if (!targetIso) return;
    var target = new Date(targetIso).getTime();
    if (isNaN(target)) return;

    var cells = {
      days: root.querySelector('[data-countdown-days]'),
      hours: root.querySelector('[data-countdown-hours]'),
      minutes: root.querySelector('[data-countdown-minutes]'),
      seconds: root.querySelector('[data-countdown-seconds]')
    };
    var endedLabel = root.getAttribute('data-ended-label') || 'Early access is live';

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function render() {
      var now = Date.now();
      var diff = target - now;
      if (diff <= 0) {
        root.setAttribute('data-state', 'ended');
        root.innerHTML = '<div class="architect-countdown--ended">' + endedLabel + '</div>';
        return false;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (cells.days) cells.days.textContent = pad(d);
      if (cells.hours) cells.hours.textContent = pad(h);
      if (cells.minutes) cells.minutes.textContent = pad(m);
      if (cells.seconds) cells.seconds.textContent = pad(s);
      return true;
    }

    if (render()) {
      var tick = setInterval(function () {
        if (!render()) clearInterval(tick);
      }, 1000);
    }
  }

  function formatMoney(cents) {
    // Basic USD formatter. For other currencies, replace with Shopify.formatMoney if available.
    if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return '$' + (parseInt(cents, 10) / 100).toFixed(2);
  }

  function initPDPVariantPicker() {
    var forms = document.querySelectorAll('.pdp-form');
    if (!forms.length) return;

    forms.forEach(function (form) {
      var hiddenInput = form.querySelector('input[name="id"]');
      if (!hiddenInput) return;
      var priceDisplay = document.querySelector('[data-price-display]');
      var addPrice = form.querySelector('[data-add-price]');
      var addLabel = form.querySelector('[data-add-label]');
      var addButton = form.querySelector('[data-add-button]');
      var buttons = form.querySelectorAll('.pdp-sizerow, .pdp-sw');

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          if (btn.hasAttribute('disabled')) return;
          e.preventDefault();

          var optionIndex = btn.getAttribute('data-option-index');
          var optionValue = btn.getAttribute('data-option-value');
          var variantId = btn.getAttribute('data-variant-id');
          var variantPrice = btn.getAttribute('data-variant-price');
          var variantAvailable = btn.getAttribute('data-variant-available') !== 'false';

          // Deselect siblings in the same radiogroup
          var group = btn.closest('[role="radiogroup"]');
          if (group) {
            var siblings = group.querySelectorAll('.pdp-sizerow, .pdp-sw');
            siblings.forEach(function (s) {
              s.classList.remove('on');
              s.setAttribute('aria-checked', 'false');
              var box = s.querySelector('.pdp-sizerow-box');
              if (box) box.textContent = '';
            });
          }

          // Select this one
          btn.classList.add('on');
          btn.setAttribute('aria-checked', 'true');
          var clickedBox = btn.querySelector('.pdp-sizerow-box');
          if (clickedBox) clickedBox.textContent = '✕';

          // Update the selected-value label (e.g., "Size — M")
          if (optionValue) {
            var labelEls = document.querySelectorAll('[data-option-selected]');
            if (labelEls[optionIndex]) {
              labelEls[optionIndex].textContent = optionValue;
            }
          }

          // Update hidden variant input + price + URL
          if (variantId) {
            hiddenInput.value = variantId;

            if (variantPrice) {
              var formatted = formatMoney(variantPrice);
              if (priceDisplay) priceDisplay.textContent = formatted;
              if (addPrice) addPrice.textContent = formatted;
            }

            if (addButton && addLabel) {
              if (variantAvailable) {
                addButton.removeAttribute('disabled');
                addLabel.textContent = 'Add to cart';
              } else {
                addButton.setAttribute('disabled', 'disabled');
                addLabel.textContent = 'Sold out';
              }
            }

            // Non-reloading URL update
            try {
              var url = new URL(window.location.href);
              url.searchParams.set('variant', variantId);
              window.history.replaceState({}, '', url);
            } catch (err) { /* noop */ }
          }
        });
      });
    });
  }

  function boot() {
    var countdowns = document.querySelectorAll('[data-architect-countdown]');
    for (var i = 0; i < countdowns.length; i++) initCountdown(countdowns[i]);
    initPDPVariantPicker();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
